module.exports = __webpack_public_path__ + "img/Cookie_1_resize_21.e409f908.png";